import React from "react";
import TitlesProps from "../Props/TitlesProps";
import { ParceriasProfissionais, ContatoData } from "../../data";
import ButtonsContact from "../Props/ButtonsContact";

export interface Area {
  id: number;
  area: string;
}

export interface Parceria {
  id: number;
  parceria: string;
}

export interface ParceriaProfissional {
  id: number;
  text: string;
  titleArea: string;
  areas: Area[];
  parcerias: Parceria[];
  text2: string;
  link: string;
}

const ParceriasProfissionaisSection: React.FC = () => {
  const data = ParceriasProfissionais[0];

  return (
    <section className="parcerias-container container">
      <TitlesProps data={ParceriasProfissionais} />
      <section className="parcerias-content">
        <p>{data.text}</p>
        <section className="parcerias-wrapper">
          <section >
            <h3>{data.titleArea}</h3>
            <section className="parcerias-list">
              <ul>
                {data.areas.map((area) => (
                  <li key={area.id}>• {area.area}</li>
                ))}
              </ul>
            </section>
          </section>
          <section>
            <h3>Tipos de Parcerias:</h3>
            <section className="parcerias-list">
              <ul>
                {data.parcerias.map((parceria) => (
                  <li key={parceria.id}>• {parceria.parceria}</li>
                ))}
              </ul>
            </section>
          </section>
        </section>

        <p>{data.text2}</p>
      </section>
      <ButtonsContact data={ContatoData} />
    </section>
  );
};

export default ParceriasProfissionaisSection;
